import React, { useEffect, useState, useContext, useRef } from "react"
import axios from "axios";
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { SidebarStateContext } from "./Dashboard";
import Searchbar from './Searchbar';
import DropNotification from './DropNotification';
import '../../App.css';
import '../styles/Sidebar.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import logoSidebar from '../../assets/southwestern-logo.webp';
import {
    DoorOpenFill,
    PersonCircle, 
    Gear,
    Bell,
    House,
    People,
    GraphUp,
    List,
    ListCheck,
    FilePost,
    FileArrowUp,
    PinMap
} from 'react-bootstrap-icons';
import { Form, Accordion, Button } from 'react-bootstrap';

/* TODO
- sidebar date and time
*/

function Sidebar({children}){
    // TODO pass isSidebarOpen to Overview in context

    // const [userLoggedSwuId, setUserLoggedSwuId] = useState(null);
    const [userLoggedName, setUserLoggedName] = useState(null);
    const [userLoggedId, setUserLoggedId] = useState(null);
    const [userLoggedRole, setUserLoggedRole] = useState(null);
    const [userLoggedPfp, setUserLoggedPfp] = useState(null);
    const [unreadNotifications, setUnreadNotifications] = useState(0);
    const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

    const navigate = useNavigate();
    const userIdRef = useRef('');
    const NotificationDot = () => (
        <div style={{
          position: 'absolute',
          top: '-5px',
          right: '-5px',
          width: '10px',
          height: '10px',
          backgroundColor: 'red',
          borderRadius: '50%',
          border: '2px solid var(--sidebar-bg)'
        }} />
    )

    useEffect(() => {
        axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true })
        .then((res) => {
          if (res.data.status === 1) {
            // console.log("User session is alive:", res.data);
            // console.log("User Full Name:", res.data.fullname);
            // console.log("User Role:", res.data.role);
            userIdRef.current = res.data.id;

            setUserLoggedName(res.data.fullname);
            setUserLoggedId(res.data.id);
            setUserLoggedRole(res.data.role);
          } else {
            //console.warn("Session error:", res.data.message);
          }

        })
        .catch((err) => {
          //console.error("ERROR: Your session cannot be found!", err);
  
        });
    }, []);

    useEffect(() => {
        if (userLoggedId) {
            const fetchData = async () => {
                await fetchPfp();
                fetchCountNotifications();
            }

            fetchData();

            const interval = setInterval(() => {
                fetchCountNotifications();
            }, 5000) // poll for new notifications every 5 seconds

            return () => clearInterval(interval);
        }
    }, [userLoggedId]);

    const fetchPfp = () => {
        axios.get(`https://docuquest-swu.swucite.tech/api_drts/users.php/${userLoggedId}/`)
        .then((res) => {
            // console.table(res.data);
            if (res.data.img_profile !== null) {
                // console.warn("profile pic: ", res.data.img_profile);
                setUserLoggedPfp(res.data.img_profile);
            } else {
                // console.warn("did not find a pfp");
            }
        })
        .catch((err) => {
            console.error(err)
        })
    }

    // Function to check if user has notifications in DropNotification.js
    const fetchCountNotifications = async () => {
        const id_user = userIdRef.current;
        const response = await axios.get(`https://docuquest-swu.swucite.tech/api_drts/userNotifications.php/${id_user}`);
        
        if (!response.data || response.data.length === 0 || response.data.status === 0) {
            setHasUnreadNotifications(false);
            return;
        } else {
            setHasUnreadNotifications(true);
        }
    }

    // Function to fetch unread notifications count
    const fetchUnreadNotifications = () => {
        axios.post('https://docuquest-swu.swucite.tech/api_drts/notificationRespond.php', {}, { withCredentials: true })
        .then((res) => {
            if (res.data.status === 1) {
                setUnreadNotifications(res.data.count);
            }
        })
        .catch((err) => {
            //console.error("Error fetching notifications:", err);
        });
    };

    // Function to mark notifications as read when bell is clicked
    const handleNotificationClick = () => {
        if (unreadNotifications > 0) {
            axios.patch('https://docuquest-swu.swucite.tech/api_drts/notificationRespond.php', {}, { withCredentials: true })
            .then(() => {
                setUnreadNotifications(0); // Reset unread count
            })
            .catch((err) => {
                //console.error("Error marking notifications as read:", err);
            });
        }
        toggleNotifications();
    };    

    // toggle quicknav active
    const isQuicknavActive = ({ isActive }) => (`quicknav item ${isActive ? 'selected' : 'clickable'}`); 

    // notification menu toggle
    const [isNotificationsOpen, doNotifications] = useState(false);
    const toggleNotifications = () => {doNotifications(!isNotificationsOpen)};

    // sidebar toggle
    // const [isSidebarOpen, doSidebar] = useState();
    // const toggleSidebar = () => {doSidebar(!isSidebarOpen)};

    const { isSidebarOpen, setIsSidebarOpen } = useContext(SidebarStateContext);
    const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

    const clientItem = [
        // {
        //     path: '/request',
        //     name: 'New Request',
        //     icon: <FilePost/>
        // },
        {
            path: '/manage/requests',
            name: 'My Requests',
            icon: <FileArrowUp/>
        },
        // {
        //     path: '/tracking/requests',
        //     name: 'Document Tracking',
        //     icon: <PinMap/>
        // }
    ]

    const staffItem = [
        {
            path: '/overview/main/',
            name: 'Dashboard',
            icon: <House/>
        },
        {
            path: '/policy',
            name: 'Policies and Guidelines',
            icon: <ListCheck/>
        }

    ]

    const adminItem = [
        {
            path: '/manage/users',
            name: 'User Management',
            icon: <People/>
        }
    ]
    
    // analytics should be in the accordion
    const analyticsItem = [
        {
            path: '/analytics/employees',
            name: 'Employee Analytics',
            icon: <GraphUp/>
        },
        // {
        //     path: '/analytics/clients',
        //     name: 'Client Analytics',
        //     icon: <GraphUp/>
        // },
        // {
        //     path: '/analytics/transactions',
        //     name: 'Transaction Analytics',
        //     icon: <GraphUp/>
        // },
        // {
        //     path: '/analytics/documents',
        //     name: 'Document Analytics',
        //     icon: <GraphUp/>
        // },
    ]

    // navigate call that takes path
    const doNavigate = (path)=>{
        navigate(path);
    }
    
    const totalEmployeeItem = [...staffItem];
    const totalAdminItem = [...totalEmployeeItem, ...adminItem];
    const totalWithAnalyticsItem = [...totalAdminItem, ...analyticsItem];
    const totalClientItem = [...clientItem];
    
    const [searchSidebarValue, setSearchSidebarValue] = useState('');
    const role = userLoggedRole ? userLoggedRole.toUpperCase() : "";

    let filteredSearchSidebar;
    
    if (searchSidebarValue) {
        // Filter based on search value and user role
        if (role === 'STAFF') {
            filteredSearchSidebar = totalEmployeeItem.filter((item) =>
                item.name.toUpperCase().includes(searchSidebarValue.toUpperCase())
            );
        } else if (role === 'ADMIN') {
            filteredSearchSidebar = totalWithAnalyticsItem.filter((item) =>
                item.name.toUpperCase().includes(searchSidebarValue.toUpperCase())
            );
        } else {
            // If no specific role, default to client view
            filteredSearchSidebar = totalClientItem.filter((item) =>
                item.name.toUpperCase().includes(searchSidebarValue.toUpperCase())
            );
        }
    } else {
        // Display full items based on user role if no search value
        filteredSearchSidebar = role === 'STAFF' 
            ? totalEmployeeItem  // searchbar empty AND user is employee, return employee modules
            : role === 'ADMIN'
            ? totalAdminItem  // searchbar empty AND user is admin, return admin modules
            : totalClientItem;  // searchbar empty AND user is client, return client modules 
    }
    
    // Show a message if no items match the search
    if (filteredSearchSidebar.length === 0) {
        filteredSearchSidebar = (
            <div style={{ color: '#f8f8f8' }}>
                No matches for "{searchSidebarValue}"
            </div>
        );
    }
    
    const handleLogout = () => {
        sessionStorage.clear();
        doNavigate('/logout');
    }

    return (
        <div className='container viewport'>
            <div style={{width: isSidebarOpen ? '22vw' : '4vw'}} className='Sidebar'>
                
                <div className='header_sidebar'>
                    {/* toggle button to show/hide sidebar */}
                    <div style={{marginLeft: isSidebarOpen ? '320px' : '120px'}} className='btn toggle' title={isSidebarOpen ? 'Hide sidebar' : 'Show sidebar'} onClick={toggleSidebar}>
                        <List/>
                    </div>

                    <p className='systemname_sidebar' style={{display: isSidebarOpen ? 'flex' : 'none'}}>
                        DocuQuest v0.1.0
                        <br/>
                        Document&nbsp;Requesting
                        and&nbsp;Tracking&nbsp;System
                    </p>
                    
                    <Link to={'/overview'}>
                    <img src={logoSidebar} alt='SWU Phinma Logo' className='logo_sidebar' title='Home' style={{display: isSidebarOpen ? 'flex' : 'none'}} />
                    </Link>

                    <div className='group_btn' style={{display: isSidebarOpen ? 'flex' : 'block'}} >

                        <NavLink to={`/profile/${userLoggedId}`} className={isQuicknavActive} >
                        {
                            userLoggedPfp ? (
                                <img
                                src={`${userLoggedPfp}`}
                                alt="Your pfp"
                                title="Profile"
                                style={{width: isSidebarOpen ? '30px' : '18px', height: isSidebarOpen ? '30px' : '18px', marginBottom: 10}}
                                className="profile-sidebar"
                                onError={(e) => { e.target.src = "https://placehold.co/27x27"; }}
                              />
                            ) : (
                                <PersonCircle title='Profile' style={{width: isSidebarOpen ? '27px' : '18px', height: isSidebarOpen ? '30px' : '18px', marginBottom: 10}}/>
                            )
                        }
                        </NavLink>
                        <NavLink to={'/settings'} className={isQuicknavActive} >
                        <Gear title='Settings' style={{width: isSidebarOpen ? '27px' : '18px', height: isSidebarOpen ? '30px' : '18px', marginBottom: 10}}/>
                        </NavLink>

                        {/* <Bell className={`quicknav item ${isNotificationsOpen ? "selected" : "clickable"}`} title='Notifications' style={{width: isSidebarOpen ? '27px' : '18px', height: isSidebarOpen ? '30px' : '18px', marginBottom: 10}} onClick={toggleNotifications}/> */}
                        
                        <div className="notification-bell-container" style={{position: 'relative'}}>
                            <Bell 
                                className={`quicknav item ${isNotificationsOpen ? "selected" : "clickable"}`} 
                                title='Notifications' 
                                style={{
                                    width: isSidebarOpen ? '27px' : '18px', 
                                    height: isSidebarOpen ? '30px' : '18px', 
                                    marginBottom: 10
                                }} 
                                onClick={handleNotificationClick}
                            />

                            {/* Red dot indicator for unread notifications */}
                            {hasUnreadNotifications && !isNotificationsOpen && <NotificationDot />}
                        </div>                        
                        
                        { isNotificationsOpen && (
                            <DropNotification
                                className={`container-notifications ${isSidebarOpen ? '' : 'minimized'}`} 
                                onNotificationRead={fetchUnreadNotifications}
                            />
                        )}
                    </div>

                    <input type="text" style={{display: isSidebarOpen ? 'flex' : 'none'}} placeholder="Search sidebar modules" className="search-input" title='Search modules' value={searchSidebarValue} onChange={(e)=>{setSearchSidebarValue(e.target.value)}} />
                </div>
                
                {/* sidebar modules */}
                {
                    filteredSearchSidebar.length > 0 ? (
                        filteredSearchSidebar.map((item, index)=>(
                            <NavLink to={item.path} key={index} className={'item_sidebar'} title={item.name} activeClassName="active">
                                <div>{item.icon}</div>
                                <div style={{display: isSidebarOpen ? 'block' : 'none'}}>{item.name}</div>
                            </NavLink>
                        )) 
                    ) : (
                        // TODO class for no matches
                        <div>
                            <p>No matches for <b>{searchSidebarValue}</b></p>
                        </div>
                    )
                }

                {/* accordion and accordion items */}
                <Accordion style={{display: role === 'ADMIN' ? 'block' : 'none'}}>
                <Accordion.Item eventKey='0'>
                    <Accordion.Header style={{display: isSidebarOpen ? 'block' : 'none'}} >Analytics</Accordion.Header>
                    <Accordion.Body>
                    {
                    analyticsItem.map((item, index)=>(
                        <NavLink to={item.path} key={index + 1} className={'item_sidebar'} title={item.name} activeClassName="active">
                            {/* TODO icon transition speed */}
                            <div>{item.icon}</div>
                            <div style={{display: isSidebarOpen ? 'block' : 'none'}}>{item.name}</div>
                        </NavLink>
                    ))
                    }
                    </Accordion.Body>
                </Accordion.Item>
                </Accordion>

            </div>
            <div className='footer_sidebar'>
            {isSidebarOpen && (
        <>
            <p className='username'>{userLoggedName}</p>
            <br />
        </>
    )}
                <Button variant="light" title='Logout' style={{display: isSidebarOpen ? 'block' : 'none'}} className='btn logout' onClick={handleLogout}>
                    <DoorOpenFill/>
                    &nbsp;
                    Logout
                </Button>
            </div>

            {/* this is the content view; whatever module you click should show its contents here */}
            <div style={{marginLeft: isSidebarOpen ? '130px' : '50px'}} className='view content' >{children}</div>
        </div>
    )
}

export default Sidebar